import React from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import Header from "../../common/Header/Header.jsx";
import ScrollToTop from "../../common/ScrollToTop/ScrollToTop.jsx";

export const AuthLayout = () => (
  <div className="mainSitelayout">
    <ScrollToTop />
    <ScrollRestoration getKey={(location) => location.pathname} />
    <Header />
    <Outlet />
  </div>
);